import loadable from "@loadable/component";

// AUTH
export const LogIn = loadable(() => import(/* webpackChunkName: "LogIn" */ "./sign-in"));
export const TwoFactorAuthentication = loadable(() => import(/* webpackChunkName: "TwoFactorAuthentication" */ "./2fa"));
export const Register = loadable(() => import(/* webpackChunkName: "Register" */ "./sign-up"));
export const OTPLogin = loadable(() => import(/* webpackChunkName: "OTPLogin" */ "./otp"));
export const ResetOTP = loadable(() => import(/* webpackChunkName: "ResetOTP" */ "./reset-otp"));
export const ForgotPassword = loadable(() => import(/* webpackChunkName: "ForgotPassword" */ "./forgot-password"));
export const ResetPassword = loadable(() => import(/* webpackChunkName: "ResetPassword" */ "./reset-password"));
export const EmailConfirm = loadable(() => import(/* webpackChunkName: "EmailConfirm" */ "./email-confirm"));
export const ChangeEmail = loadable(() => import(/* webpackChunkName: "ChangeEmail" */ "./change-email"));
export const MagicLink = loadable(() => import(/* webpackChunkName: "MagicLink" */ "./magic-link"));
export const MagicReceiver = loadable(() => import(/* webpackChunkName: "MagicReceiver" */ "./magic-receiver"));
